










import { useRoute } from '@/app/composable/router';
import { WorkflowType } from '@/app/constants/workflow-type.constants';
import store from '@/app/store';
import { ExecutionHistory } from '@/modules/workflow-designer/components/execution-history';
import { computed, defineComponent, watch } from '@vue/composition-api';
import { useApolloPipeline } from '../composable';

export default defineComponent({
    name: 'DataCheckinPipelineExecutionHistory',
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    components: { ExecutionHistory },
    setup: (props: any, { root }: { root: any }) => {
        const route = useRoute();

        const onFetchPipelineError = (e: any) => {
            if (e.response?.status === 403) {
                (root as any).$toastr.e('You do not have access to view this page.', 'Access Denied');
                root.$router.push({ name: 'data-checkin-jobs', query: store.state.queryParams.jobs });
            } else {
                root.$toastr.e(`Ingestion Job could not be fetched`, 'Error');
            }
        };

        const pipelineId = computed((): string => props.id);

        const { pipeline, fetchPipeline, isLongRunning } = useApolloPipeline(pipelineId, onFetchPipelineError);
        const routerName = computed(() => route.name);

        watch(
            () => pipelineId.value,
            () => fetchPipeline(),
        );

        return { pipeline, WorkflowType, routerName, isLongRunning, pipelineId };
    },
});
